import React from 'react';
import ReactQuill from 'react-quill';
import { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);

const RichTextEditor = React.forwardRef(({ value, onChange, ...rest }, ref) => {
  return <ReactQuill {...rest} value={value} onChange={onChange} ref={ref} />;
});

export default RichTextEditor;
